module.exports = __webpack_public_path__ + "static/media/morango.880d2a03.png";